<template>
  <div class="text-start mx-1">
    <v-dialog v-model="isOpen" width="500">
      <template v-slot:activator="{ on, attrs }">
        <v-icon small color="error" class="mx-2" v-bind="attrs" v-on="on">mdi-truck-fast</v-icon>
      </template>
      <v-card>
        <v-card-title class="text-h5 lighten-2">
          <v-icon color="error" class="mr-2" v-bind="attrs" v-on="on">mdi-truck-fast</v-icon>
          Tracking Number
        </v-card-title>
        <v-card-text class="text-body lighten-2">System will send SMS to a user</v-card-text>
        <v-card-text>
          <v-container>
            <v-text-field label="Enter tracking number" type="text" v-model="trackNumber" required></v-text-field>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="handleClose"> Close </v-btn>
          <v-btn color="primary" text @click="handleSubmit"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PrescriptionService from '../../../services/prescription';

export default {
  name: 'AddTrackingNumberDialog',
  props: ['epresOrder', 'onSubmitted'],
  data() {
    return {
      isOpen: false,
      trackNumber: '',
    };
  },
  methods: {
    handleClose() {
      this.isOpen = false;
      this.trackNumber = this.epresOrder.trackingNumber;
    },
    handleSubmit() {
      const prescriptionId = this.epresOrder.value._id;
      const param = {
        orderNumber: this.epresOrder.orderNumber,
        trackingNumber: this.trackNumber,
        patientId: this.epresOrder.value.patientId,
        prescriptionId,
      };

      PrescriptionService.updateTrackingNumber(prescriptionId, param)
        .then(() => {
          if (this.onSubmitted) {
            this.onSubmitted();
          }
          this.isOpen = false;
        })
        .catch((err) => console.log(err));
    },
  },
  mounted() {
    this.trackNumber = this.epresOrder.trackingNumber;
  },
};
</script>
